import { ICON__brush_clean } from '@/assets/icons_lucide';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { PLACEHOLDER_BUTTON__bar_10_5 } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar_10_5';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';

export function G_BUTTON__fields_images_clear_content() {
  const { generation_current } = use_slice_generation(['generation_current']);
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);

  let { graph } = generation_current.tool;

  async function onClick() {
    let fields_images = graph.fields__get_by_type(FIELD__image_asset);
    fields_images = fields_images.filter(field => !field.is_stub());
    fields_images = fields_images.filter(field => field.is_ready_for_manual_edit());
    fields_images = fields_images.filter(field => field.get_has_content());

    let fields_images_new = fields_images.map(field => field.clone());

    let graph_new = graph.clone();

    for (let field of fields_images_new) {
      field.image__clear();

      graph_new.field__replace(field);
    }

    await UTILS__graph_data.update(graph_new);
  }

  function is_disabled() {
    return g_general__ui_disabled;
  }

  if (generation_current.is_stub()) return <PLACEHOLDER_BUTTON__bar_10_5 />;

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      variant="no-border-on-component"
      size="icon"
      disabled={is_disabled()}
      {...{ onClick }}
      iconClassNameBase="!text-component-item-foreground !size-3"
      iconClassNameHovered="!text-bar-foreground"
      Icon={ICON__brush_clean}
    />
  );
}
